import { useState, useEffect } from 'react';

/**
 * Detecta si se debe mostrar la versión móvil
 * según las dimensiones de la ventana.
 *
 * Se considera móvil cuando:
 * - El ancho es menor a 992px, o
 * - El alto es menor a 797px.
 *
 * @returns {boolean} true si se debe mostrar la versión móvil,
 * false si se debe mostrar la versión desktop.
 */
function useIsAdvancedSearchMobile() {
    const getIsMobile = () => {
        return window.innerWidth < 992 || window.innerHeight < 798;
    };

    const [isMobile, setIsMobile] = useState(getIsMobile);

    useEffect(() => {
        const setMobile = () => {
            setIsMobile(getIsMobile());
        };

        window.addEventListener('resize', setMobile);

        return () => {
            window.removeEventListener('resize', setMobile);
        };
    }, []);

    return isMobile;
}

export default useIsAdvancedSearchMobile;